import { render, staticRenderFns } from "./tableTemplate.vue?vue&type=template&id=1af31284&scoped=true&"
import script from "./tableTemplate.vue?vue&type=script&lang=js&"
export * from "./tableTemplate.vue?vue&type=script&lang=js&"
import style0 from "./tableTemplate.vue?vue&type=style&index=0&id=1af31284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af31284",
  null
  
)

export default component.exports